<template>
  <el-select
    :loading="isLoadingRef"
    :multiple="multiple"
    :placeholder="$t('placeholder.select')"
    :remote-method="updateStoreListByKeyword"
    :value="value"
    :clearable="clearable"
    remote
    filterable
    @change="handleUpdateSelectedStores"
  >
    <el-option
      v-for="item in storesRef"
      :key="item.slug"
      :label="item.name"
      :value="item[valueKey]"
    />
  </el-select>
</template>

<script>
import { createComponent, ref, computed, onMounted } from '@vue/composition-api'

import VaderService from '../../api/vader'
import VaderUtils from '../../utils/vader'

const StoreSelector = createComponent({
  props: {
    value: {
      type: [Array, String, Number],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    valueKey: {
      type: String,
      default: 'slug',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isLoadingRef = ref(false)
    const classNames = computed(() => ({
      'w-100': props.fullWidth,
    }))

    const storesRef = ref([])
    const updateStoreListByKeyword = async (query) => {
      if (query !== '') {
        isLoadingRef.value = true;
        try {
          const data = await VaderService.getStores(query)
          storesRef.value = VaderUtils.handleStoreNameCollision(data.data.data)
        } finally {
          isLoadingRef.value = false
        }
      } else {
        storesRef.value = [];
      }
    }
    const handleUpdateSelectedStores = (values) => {
      emit('input', values)
    }

    onMounted(() => {
      if (props.multiple) {
        handleUpdateSelectedStores([])
      }
    })

    return {
      isLoadingRef,
      classNames,

      storesRef,

      updateStoreListByKeyword,
      handleUpdateSelectedStores,
    }
  },
})

export default StoreSelector
</script>
